import React, { Fragment } from 'react';

import InvoiceItem from 'components/Core/Invoice/InvoiceItem/InvoiceItem';
import { LineItem } from 'types/Sale';

export interface InvoiceItemsListProps {
  lineItems?: LineItem[];
  currency?: string;
}

const InvoiceItemsList = ({ lineItems, currency }: InvoiceItemsListProps) => {
  const getListOfItems = (lineItems?: LineItem[]) =>
    lineItems?.map((lineItem: LineItem, index: number) => {
      const { amount, item, quantity } = lineItem;

      // Extract description - prefer item.name, fallback to description
      let itemDescription;
      if (item && item.name) {
        itemDescription = item.name;
      } else if (lineItem.description) {
        itemDescription = lineItem.description;
      } else {
        return <Fragment key={index} />;
      }

      return (
        <InvoiceItem
          description={itemDescription}
          amount={amount}
          currency={currency}
          quantity={quantity}
          key={index}
        />
      );
    });

  return <div>{getListOfItems(lineItems)}</div>;
};

export default InvoiceItemsList;
